import * as classnames from "classnames";

import { SupportedProgrammingLanguagesLink } from "@components/user/modals/partials/SupportedProgrammingLanguagesLink";

import {
  Form,
  FormGroup,
  Icon,
  Msg,
  Select,
  SelectItem,
} from "@shared/components";
import { ApplicantChallengeModel } from "@shared/models";
import { ProgrammingLanguage } from "@shared/services/enums";

export type ProgrammingLanguagePanelPropsNew = {
  // TTODO: Rename this once isWebCamEnabled feature flag is removed
  challenge: ApplicantChallengeModel;
  initialValue?: ProgrammingLanguage;
  onChange: (programmingLanguage: ProgrammingLanguage) => void;
};

export const ProgrammingLanguagePanelNew = ({
  // TTODO: Rename this once isWebCamEnabled feature flag is removed
  initialValue,
  challenge,
  onChange,
}: ProgrammingLanguagePanelPropsNew) => {
  // TTODO: Rename this once isWebCamEnabled feature flag is removed
  const options = challenge.programmingLanguages.map((item) => {
    return {
      label: ProgrammingLanguage.toString(item),
      value: item,
    } as SelectItem;
  });

  const rootStyle = classnames("code-programming-language-panel-new"); // TTODO: Rename this class once isWebcamEnabled feature flag is removed

  const onFormChange = (
    formValid: boolean,
    formValues: { programmingLanguage: ProgrammingLanguage },
  ) => {
    onChange(formValues.programmingLanguage);
  };

  return (
    <div className={rootStyle}>
      <div>
        <div className="code-c-walk-through__item__subtitle">
          <Msg id="start-challenge-walkthrough.setup.language.title" />
        </div>
        <Msg
          id="start-challenge-walkthrough.setup.language.choose"
          values={{
            cog: <Icon type="cog" />,
          }}
        />
        <SupportedProgrammingLanguagesLink />
      </div>
      <Form
        className="code-programming-language-panel__form"
        validation={{
          programmingLanguage: ["required"],
        }}
        initialValues={{
          programmingLanguage: initialValue,
        }}
        onFormChange={onFormChange}
      >
        <FormGroup>
          <Select
            name="programmingLanguage"
            innerClassName="is-small"
            options={options}
          />
        </FormGroup>
      </Form>
    </div>
  );
};
